export const otorhinolaryngologyConst = {
  path: "/single-programs/otorhinolaryngology",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — ОТОРИНОЛАРИНГОЛОГИЯ (ЛОР)",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Оториноларингология — медицина слуха, речи и дыхания</h2>
      <p>
        Оториноларингология — это клиническая дисциплина, изучающая анатомию, физиологию, патологии и методы лечения заболеваний уха, горла,
        носа и прилегающих структур головы и шеи. Специальность охватывает широкий спектр заболеваний — от тонзиллита и ринита до
        тугоухости, нарушений равновесия и опухолей ЛОР-органов.
      </p>
      <p>
        Программа сочетает теоретическую базу, интенсивную клиническую подготовку и практические навыки по амбулаторной и хирургической
        помощи.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Анатомия и физиология ЛОР-органов</li>
        <li>Диагностика заболеваний уха, горла, носа</li>
        <li>Методы отоскопии, риноскопии, фарингоскопии</li>
        <li>ЛОР-хирургия: аденотомия, тонзиллэктомия, септопластика</li>
        <li>Аудиология и речевые расстройства</li>
        <li>Вестибулярные расстройства и реабилитация</li>
        <li>Инфекции верхних дыхательных путей и их осложнения</li>
        <li>Аллергические реакции и хронические состояния</li>
        <li>Коммуникация с пациентами и клиническая этика</li>
      </ul>
      <p>Студенты проходят стажировки в профильных отделениях больниц, ЛОР-клиниках, специализированных диагностических центрах.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>ЛОР-врач в поликлинике или стационаре</li>
        <li>Хирург-оториноларинголог</li>
        <li>Специалист по аудиологии и слуховым аппаратам</li>
        <li>Консультант по детской или взрослой ЛОР-патологии</li>
        <li>Научный сотрудник в области ЛОР-исследований</li>
      </ul>
      <h2>Востребованность и доход</h2>
      <p>Проблемы со слухом, голосом, носовым дыханием — одни из самых частых в медицине.</p>
      <p>
        <strong>Средняя зарплата ЛОР-врача в Европе — от €60,000 до €110,000 в год,</strong> в частной практике — выше.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Программа с клиническим уклоном</li>
        <li>Возможность учиться очно или дистанционно</li>
        <li>Обучение на русском и английском языках</li>
        <li>Практика в профильных ЛОР-клиниках и хирургических отделениях</li>
        <li>Поддержка студентов и помощь в трудоустройстве</li>
        <li>Диплом магистра европейского образца</li>
      </ul>
      <h2>Специализация, важная для качества жизни</h2>
      <p>
        Оториноларингологи помогают людям слышать, говорить и дышать свободно. Это профессия с высоким уровнем доверия и уважения в
        обществе.
      </p>
      <br />
      <p className="padding-left">«ЛОР-врач — это врач, к которому приходят за голосом, слухом и здоровым дыханием.»</p>
      <h2>Как поступить?</h2>
      <p>
        Подайте онлайн-заявку, прикрепите документы и получите консультацию от приёмной комиссии. Мы сопроводим вас на каждом этапе
        поступления.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии

    Оториноларингология — медицина слуха, речи и дыхания
    Оториноларингология — это клиническая дисциплина, изучающая анатомию, физиологию, патологии и методы лечения заболеваний уха, горла, носа и прилегающих структур головы и шеи. Специальность охватывает широкий спектр заболеваний — от тонзиллита и ринита до тугоухости, нарушений равновесия и опухолей ЛОР-органов.
    Программа сочетает теоретическую базу, интенсивную клиническую подготовку и практические навыки по амбулаторной и хирургической помощи.

    Что вы будете изучать?
    • Анатомия и физиология ЛОР-органов
    • Диагностика заболеваний уха, горла, носа
    • Методы отоскопии, риноскопии, фарингоскопии
    • ЛОР-хирургия: аденотомия, тонзиллэктомия, септопластика
    • Аудиология и речевые расстройства
    • Вестибулярные расстройства и реабилитация
    • Инфекции верхних дыхательных путей и их осложнения
    • Аллергические реакции и хронические состояния
    • Коммуникация с пациентами и клиническая этика
    Студенты проходят стажировки в профильных отделениях больниц, ЛОР-клиниках, специализированных диагностических центрах.

    Кем можно работать после окончания?
    • ЛОР-врач в поликлинике или стационаре
    • Хирург-оториноларинголог
    • Специалист по аудиологии и слуховым аппаратам
    • Консультант по детской или взрослой ЛОР-патологии
    • Научный сотрудник в области ЛОР-исследований

    Востребованность и доход
    Проблемы со слухом, голосом, носовым дыханием — одни из самых частых в медицине.
    Средняя зарплата ЛОР-врача в Европе — от €60,000 до €110,000 в год, в частной практике — выше.

    Почему выбирают нас?
    • Программа с клиническим уклоном
    • Возможность учиться очно или дистанционно
    • Обучение на русском и английском языках
    • Практика в профильных ЛОР-клиниках и хирургических отделениях
    • Поддержка студентов и помощь в трудоустройстве
    • Диплом магистра европейского образца

    Специализация, важная для качества жизни
    Оториноларингологи помогают людям слышать, говорить и дышать свободно. Это профессия с высоким уровнем доверия и уважения в обществе.
    «ЛОР-врач — это врач, к которому приходят за голосом, слухом и здоровым дыханием.»

    Как поступить?
    Подайте онлайн-заявку, прикрепите документы и получите консультацию от приёмной комиссии. Мы сопроводим вас на каждом этапе поступления.
  `,
};
